import { useState, useCallback } from 'react'

export function useToast() {
  const [toast, setToast] = useState(null)

  const showToast = useCallback((message, type = 'default') => {
    setToast({ message, type, id: Date.now() })

    // Auto-dismiss after 3 seconds
    setTimeout(() => {
      setToast(null)
    }, 3000)
  }, [])

  const dismissToast = useCallback(() => {
    setToast(null)
  }, [])

  return { toast, showToast, dismissToast }
}
